module.exports = require('./dist/shared/lib/amp')
